import { render } from "./CalculationItemDimensions.vue?vue&type=template&id=faa1ad5a&scoped=true"
import script from "./CalculationItemDimensions.vue?vue&type=script&lang=js"
export * from "./CalculationItemDimensions.vue?vue&type=script&lang=js"

import "./CalculationItemDimensions.vue?vue&type=style&index=0&id=faa1ad5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa1ad5a"]])

export default __exports__